import {
  LayoutDashboard, Target, KanbanSquare, Users, FolderClosed, Clock,
  Wallet, BarChart3, CheckSquare, BookOpen, Calendar, ShieldCheck, Settings, ListChecks,
} from "lucide-react";

// Ordered per user priority. `built` flag drives placeholder routing.
export const MODULES = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/", built: true, sub: null },
  { key: "my-work", label: "My Work", icon: ListChecks, path: "/my-work", built: true, sub: null },
  {
    key: "crm", label: "Pre-Sales & CRM", icon: Target, path: "/crm/dashboard", built: true,
    sub: [
      { label: "Dashboard", path: "/crm/dashboard" },
      { label: "Leads", path: "/crm/leads" },
      { label: "Clients", path: "/crm/clients" },
      { label: "Reports", path: "/crm/reports" },
      { label: "Pipelines", path: "/crm/pipelines", action: "edit" },
      { label: "Project Types", path: "/crm/project-types", action: "edit" },
    ],
  },
  {
    key: "pm", label: "Project Management", icon: KanbanSquare, path: "/pm/dashboard", built: true,
    sub: [
      { label: "Dashboard", path: "/pm/dashboard" },
      { label: "Projects", path: "/pm/projects" },
      { label: "Workload", path: "/pm/workload" },
      { label: "Global Board", path: "/pm/global-board" },
      { label: "Reports", path: "/pm/reports" },
      { label: "Board Templates", path: "/pm/pipelines", action: "edit" },
      { label: "Task Templates", path: "/pm/task-templates", action: "edit" },
    ],
  },
  {
    key: "hrms", label: "HRMS", icon: Users, path: "/hrms/analytics", built: true,
    sub: [
      { label: "Analytics", path: "/hrms/analytics" },
      { label: "Directory", path: "/hrms/directory" },
      { label: "Document Templates", path: "/hrms/templates" },
      { label: "Recruitment", path: "/hrms/recruitment" },
      { label: "Leave", path: "/hrms/leave" },
      { label: "Attendance", path: "/hrms/attendance" },
      { label: "Assets", path: "/hrms/assets" },
      { label: "Onboarding", path: "/hrms/onboarding" },
      { label: "Offboarding", path: "/hrms/offboarding" },
      { label: "My HR", path: "/hrms/me" },
      { label: "Profile Requests", path: "/hrms/profile-requests", action: "approve" },
      { label: "Performance", path: "/hrms/performance" },
      { label: "Recognition", path: "/hrms/recognition" },
      { label: "Payroll", path: "/hrms/payroll" },
    ],
  },
  { key: "dms", label: "Documents", icon: FolderClosed, path: "/dms", built: true, sub: null },
  {
    key: "timesheets", label: "Timesheets", icon: Clock, path: "/timesheets/week", built: true,
    sub: [
      { label: "My Timesheet", path: "/timesheets/week" },
      { label: "Approvals", path: "/timesheets/approvals" },
      { label: "Status", path: "/timesheets/status" },
    ],
  },
  {
    key: "finance", label: "Finance", icon: Wallet, path: "/finance/invoices", built: true,
    sub: [
      { label: "Invoices", path: "/finance/invoices" },
      { label: "Profitability", path: "/finance/dashboard" },
      { label: "Expenses & Approvals", path: "/finance/expenses" },
      { label: "Cost Centers", path: "/finance/cost-centers" },
      { label: "Chart of Accounts", path: "/finance/chart-of-accounts" },
    ],
  },
  { key: "reporting", label: "Reporting", icon: BarChart3, path: "/reporting/dashboards", built: true,
    sub: [
      { label: "Dashboards", path: "/reporting/dashboards" },
      { label: "Standard Reports", path: "/reporting/standard" },
    ] },
  { key: "todo", label: "To-Do", icon: CheckSquare, path: "/todo", built: true, sub: null },
  { key: "kb", label: "Knowledge Base", icon: BookOpen, path: "/kb", built: true, sub: null },
  { key: "calendar", label: "Calendar", icon: Calendar, path: "/calendar", built: true, sub: null },
  { key: "compliance", label: "Compliance", icon: ShieldCheck, path: "/compliance", built: true, sub: null },
];

export const SETTINGS_MODULE = {
  key: "settings", label: "Settings", icon: Settings, path: "/settings/users", built: true,
  sub: [
    { label: "Users & Roles", path: "/settings/users" },
    { label: "Company", path: "/settings/company" },
    { label: "Signature Directory", path: "/settings/signature-directory" },
    { label: "Currency & Tax", path: "/settings/currency" },
    { label: "Data Backup", path: "/settings/backup" },
    { label: "Audit Log", path: "/settings/audit-log" },
    { label: "Integrations", path: "/settings/integrations", action: "override" },
    { label: "Usage Metrics", path: "/settings/usage-metrics", action: "override" },
    { label: "My Profile", path: "/profile" },
  ],
};
